import { IDescriptionRowLayout } from '../model';

export const DESCRIPTION_ROW_ICON_INFO: IDescriptionRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 1.25,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 1.25,
      },
    },
    size: { xs: 1, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0.5,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 10, sm: 10, md: 10, lg: 10 },
  },
};

export const DESCRIPTION_ROW_INFO: IDescriptionRowLayout = {
  visible: true,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 1.25,
      },
    },
    size: { xs: 0, sm: 1, md: 1, lg: 1 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: true,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: true,
        paddingLeft: 1,
        paddingRight: 0,
      },
    },
    size: { xs: 10, sm: 10, md: 10, lg: 10 },
  },
};

export const DESCRIPTION_ROW_DISABLED: IDescriptionRowLayout = {
  visible: false,
  firstColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
  secondColumn: {
    deviceSettings: {
      mobile: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
      desktop: {
        visible: false,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    size: { xs: 0, sm: 0, md: 0, lg: 0 },
  },
};
